export function homeHeader() {
    $('#main-logo-min').show();
    /*
  $(window).on('scroll', function() {
    let scroll = $(window).scrollTop();
    if (scroll >= 500) {
      $(".header").addClass("blackBg");
    } else {
      $(".header").removeClass("blackBg");
    }
  });*/
}


// WEBPACK FOOTER //
// ./assets/js/modules/homeHeader.js